import React, { useState, useEffect } from 'react';

import ConfirmButton from '../../ConfirmButton/ConfirmButton';
import { JOKI } from '../../../JOKI';

// import { rebootDevice, connectDeviceToVpn } from "../../../actions/devicesActions";

import arrayCompare from '../../../utils/arrayCompare';

import './DeviceManagementActions.scss';

// Currently on hold

// export default function DeviceManagementActions(props) {
//     return (
//         <div className="device-management-actions">
//             <h2>No actions available in the current version</h2>
//         </div>
//     );
// }

function updateAvailableCommands(device) {
    const res = JOKI.ask({
        to: 'DevicesService',
        key: 'commandsForDevice',
        body: device,
        syncAsk: true,
    });
    return res.DevicesService;
}

export default function DeviceManagementActions(props) {
    const { device } = props;
    const { permissions } = props;

    const [availableCommands, setAvailableCommands] = useState(() => updateAvailableCommands());
    const [actionsAvailable, setActionsAvailable] = useState(true);

    function commandClicked(cmd, params = null) {
        JOKI.trigger({
            to: 'DevicesService',
            key: 'executeDeviceCommand',
            body: {
                device: device,
                command: cmd,
                params: params,
            },
        });
    }

    useEffect(() => {
        if (device !== undefined && typeof updateAvailableCommands === 'function') {
            const commands = updateAvailableCommands(device).filter(com => permissions.includes('organizationCRUD') || (!com.includes('Vpn') && !com.includes('provision')));
            
            if (!arrayCompare(commands, availableCommands)) {
                setAvailableCommands(commands);
            }
        }
    }, [device, availableCommands]);

    useEffect(() => {
        if (device !== undefined) {
            setActionsAvailable(true);
            
        }
    }, [device]);

    if (availableCommands.length === 0 || !actionsAvailable) {
        return (
            <div className="device-management-actions">
                <h2 className="no-actions">No actions available for this device</h2>
            </div>
        );
    }

    return (
        <div className="device-management-actions">
            {availableCommands.map(cmd => (
                <ActionButton key={cmd} device={device} action={cmd} onClick={commandClicked} setActionsAvailable={setActionsAvailable} />
            ))}
        </div>
    );
}

/**
 * ACtion Button is a generic wrapper for confirm button
 * @param {*} props
 */
function ActionButton(props) {
    const { device, action, onClick, setActionsAvailable } = props;

    const vpnOptions = [
        { label: 'Legacy', value: 'legacy' },
        { label: 'Slot 1', value: 'slot1' },
        { label: 'Slot 2', value: 'slot2' },
        { label: 'Slot 3', value: 'slot3' },
        { label: 'Slot 4', value: 'slot4' },
        { label: 'Slot 5', value: 'slot5' },
        { label: 'Slot 6', value: 'slot6' },
        { label: 'Slot 7', value: 'slot7' },
        { label: 'Slot 8', value: 'slot8' },
        { label: 'Slot 9', value: 'slot9' },
        { label: 'Slot 10', value: 'slot10' },
    ];

    let actions = {};
    const resolvedDeviceName = device.name ? `device ${device.name}` : "this device";

    if (device.lifeCycleStatus === 'OPERATIONAL') {
        actions = {
            openDoor: {
                text: 'Open Door',
                question: `Are you sure you want to open the door of ${resolvedDeviceName}`,
                icon: 'lock_open',
                theme: 'positive',
            },
            closeDoor: {
                text: 'Close Door',
                question: `Are you sure you want to close the door of ${resolvedDeviceName}`,
                icon: 'lock',
                theme: 'primary',
            },
            reboot: {
                text: 'Reboot Device',
                question: `Are you sure you want to reboot ${resolvedDeviceName}`,
                icon: 'power_settings_new',
                theme: 'negative',
            },
            cabinetReboot: {
                text: 'Reboot Cabinet',
                question: `Are you sure you want to reboot ${resolvedDeviceName}`,
                icon: 'power_settings_new',
                theme: 'negative',
            },
            hardReset: {
                text: 'Hard Reset',
                question: `Are you sure you want to reboot ${resolvedDeviceName}`,
                icon: 'restore',
                theme: 'negative',
            },
            maintenanceModeOn: {
                text: 'Start Maintenance',
                question: `Are you sure you want to start maintenance for ${resolvedDeviceName}`,
                icon: 'build',
                theme: 'positive',
            },
            maintenanceModeOff: {
                text: 'Stop Maintenance',
                question: `Are you sure you want to stop the maintenance of ${resolvedDeviceName}`,
                icon: 'build',
                theme: 'primary',
            },
            default: {
                text: `${action}?`,
                question: `Are you sure you want to to execute an unknown command ${action} for ${resolvedDeviceName}`,
                icon: 'error_outline',
                theme: 'secondary',
            },
        };
    }

    if (device.lifeCycleStatus === 'READY' || device.lifeCycleStatus === 'OPERATIONAL') {
        const provisioningAppUrl = process.env.REACT_APP_PROVISIONING_APP_URL;

        actions = {
            ...actions,
            provision: {
                text: 'Open Provisioning app',
                question: `Are you sure you want to open provisioning application for ${resolvedDeviceName}?`,
                icon: 'open_in_new',
                theme: 'positive',
                commandParams: { provisioningAppUrl },
            },
        };
    }

    if (device.lifeCycleStatus === 'READY' || device.lifeCycleStatus === 'INSTALLED' || device.lifeCycleStatus === 'OPERATIONAL') {

        actions = {
            ...actions,
            openVpn: {
                text: 'Open VPN',
                question: `Please select one of the VPN slots for ${resolvedDeviceName}`,
                icon: 'vpn_lock',
                theme: 'positive',
                selectOptions: vpnOptions,
            },
            closeVpn: {
                text: 'Close VPN',
                question: `Are you sure you want to close a VPN connection to ${resolvedDeviceName}`,
                icon: 'vpn_lock',
                theme: 'primary',
            },
        };
    }

    function commandClicked(params) {
        if (typeof onClick === 'function') {
            onClick(action, params);
        }
    }

    // This will signal the parent component that because of devices life cycle status,
    // there is no action is available for this device
    if (Object.keys(actions).length === 0) {
        setActionsAvailable(false);
    } else {
        setActionsAvailable(true);
    }

    if (actions[action] === undefined) {
        return null;
    }

    const data = actions[action]; 

    return (
        <ConfirmButton
            icon={data.icon}
            type={data.theme}
            title={data.text}
            onClick={selectedOption => commandClicked({ commandParams: data.commandParams, selectedOption })}
            modalContent={data.question}
            selectOptions={data.selectOptions}>
            {data.text}
        </ConfirmButton>
    );
}
